import './css/dashboardtable.css';
import './css/editform.css';
import React, { useState, useEffect } from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom';




function EditServices() {



    useEffect(() => {
        axios.get('session')
            .then((res) => {
                if (res.data.valid) {
                    if (res.data.type !== "admin") {
                        navigate('/admin-login');
                    }
                } else {
                    // Handle the case when session is not valid
                }
            })
            .catch((err) => console.log(err));
    }, []);




    const [formChanged, setFormChanged] = useState(false); // Track if the form has changed


    const handleInputChange = () => {
        setFormChanged(true); // Set the formChanged flag to true when any input changes
    };




    const navigate = useNavigate();
    const [service, setService] = useState({});
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');


    const [formInputs, setFormInputs] = useState({
        header: "",
        para: "",
        cat_id: "",
        img: null,
    });
    
    // Use formInputs to set the initial value of inputs
    useEffect(() => {
        if (service.id) {
        setFormInputs({
            header: service.header,
            para: service.para,
            cat_id: service.cat_id,
            img: null,
        });
        }
    }, [service]);

        const handleChange = (e) => {
            handleInputChange();
            const { name, value, type } = e.target;
            const inputValue = type === "file" ? e.target.files[0] : value;
        
            setFormInputs((prevFormInputs) => ({
            ...prevFormInputs,
            [name]: inputValue,
            }));
        };


        
        const handleSubmit = async (e) => {
            e.preventDefault();
        
            let Loading = document.querySelector(".loading-screen");
            Loading.classList.add("active");
        
            const { header,para,cat_id, img } = formInputs;
        
            if (!header) {
            return alert("All fields are required");
            }
                    
            if (!para) {
                return alert("All fields are required");
            }        
            if (!cat_id) {
            return alert("All fields are required");
            }
        
            try {
            const form = new FormData();
            form.append("id", id);
            form.append("header", header);
            form.append("para", para);
            form.append("cat_id", cat_id);
            form.append("img", img);
        
            const response = await axios.post("/update-service", form);
        
            if (response.status === 200) {
                // Update LandingSlide state after a successful update
                setService((prevService) => ({
                ...prevService,
                header,
                para,
                cat_id,


                }));
        
                Loading.classList.remove("active");
                let alertS = document.querySelector(".alert-success");
                alertS.classList.add("active");
        
                setTimeout(() => {
                alertS.classList.remove("active");
                }, 3000);
            } else {
                Loading.classList.remove("active");
                let alertD = document.querySelector(".alert-danger");
                alertD.classList.add("active");
                setTimeout(() => {
                alertD.classList.remove("active");
                }, 3000);
            }
            } catch (error) {
            console.error(error);
            alert("Server error");
            }
        };




    axios.defaults.withCredentials = true;
    
    const getService = (itemId) => {
        let table = "services";
        axios.post('get-item', { itemId, table })
            .then((res) => {
                if (res.data.message) {
                } else {
                    setService(res.data);
                }
            })
            .catch((err) => console.log(err));
    };




    const getIfLogin = () => {
        axios.get('session')
            .then((res) => {
                if (!res.data.valid || id <= 0 || id == null || id == "") {
                    navigate('/admin-login');
                } else {
                    getService(id);
                }
            })
            .catch((err) => console.log(err));
    };
    

    
    const [AllCategories, setAllCategories] = useState([]);

    
    const getAllCategories = ()=>{
        axios.post('AllItems', {
            table: 'categories',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllCategories(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    




    useEffect(() => {
        getIfLogin();
        getService(id);
        getAllCategories();
    }, []);
    
    return (
        <>

<div className='loading-screen'>
                            <div class="loader">
                                <div class="outer"></div>
                                <div class="middle"></div>
                                <div class="inner"></div>
                            </div>

                        </div>
            <section className='dashboard'>
                <div className='edit-form'>

                <div className='alert-success'>
                        <h1> Data updated successfully  <i class="las la-check-circle"></i></h1>
                    </div>

                    <div className='alert-danger'>
                        <h1> Failed To Update Data <i class="las la-exclamation-triangle"></i></h1>

                    </div>



                    <h1>  Edit Service </h1>
                    <form onSubmit={handleSubmit}>
                
                            <div className='input'>
                                <label> Service Name  </label>
                                <input value={formInputs.header}  onChange={handleChange} type='text' required="required"  maxLength="250" name='header'/>
                            </div>




                        <div className='input'>
                                <label> Service Description  </label>
                                <textarea  value={formInputs.para}  onChange={handleChange} type='text' required="required"  maxLength="700" name='para'>
                                    
                                </textarea>
                            </div>


                                
                        <div className='input'>
                            <label> Service Category  </label>
                            <select value={formInputs.cat_id} onChange={handleChange} required="required"  name='cat_id'>
                                <option value=""> Choose Category </option>
                                {
                                AllCategories.map((category) => (
                                    <option key={category.id} value={category.id}>{category.header}</option>
                                ))
                                }


                            </select>
                        </div>



                            <div className='input'>
                                <label> Image  </label>
                                <input onChange={handleChange} type='file' name="img" accept="image/*"/>
                            </div>



                                <button disabled={!formChanged} type='submit'> update </button>
                            </form>
                        </div>
                    </section>
                </>
            );
            }
            


            export default EditServices;
